if (!customElements.get('dark-mode')) {
  class DarkMode extends HTMLElement {
    constructor() {
      super();
      this.DARK_MODE_NAME = 'darkmode';

      this.input = this.querySelector('.js-darkmode-input');
    }

    connectedCallback() {
      this.checkDarkMode();
      this.toggleMode();
    }

    checkDarkMode() {
      // const darkModeState = localStorage.getItem(this.DARK_MODE_NAME);

      // if (darkModeState) {
      //   this.darkMode = darkModeState;
      //   if (this.darkMode == 'dark') this.input.checked = true;
      // } 
      // // else this.getModeByTime();

      // this.applyMode();
    }

    getModeByTime() {
      const date = new Date();
      let hour = date.getHours();
      hour >= 18 ? (this.darkMode = 'dark') : (this.darkMode = 'light');
    }

    toggleMode() {
      this.input.addEventListener('change', () => {
        this.darkMode == 'light' ? (this.darkMode = 'dark') : (this.darkMode = 'light');
        this.applyMode();
      });
    }

    applyMode() {
      const body = document.body;
      body.classList.remove('dark', 'light');
      body.classList.add(this.darkMode);
      localStorage.setItem(this.DARK_MODE_NAME, this.darkMode);
    }
  }

  customElements.define('dark-mode', DarkMode);
}
